var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Theme auswahl")]),_c('p'),_c('v-select',{attrs:{"items":_vm.selectableThemes,"outlined":""},on:{"change":_vm.themeChanged},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(_vm.getEnumName(item))+" ")])]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(_vm.getEnumName(item))+" ")])]}}]),model:{value:(_vm.selectedTheme),callback:function ($$v) {_vm.selectedTheme=$$v},expression:"selectedTheme"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }